$ = require 'jquery'
Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
{ Analytics } = require '@trello/atlassian-analytics'
BoardDisplayHelpers = require 'app/scripts/views/internal/board-display-helpers'
Controller = require 'app/scripts/controller'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
Confirm = require 'app/scripts/views/lib/confirm'
SharePopoverView = require 'app/scripts/views/board/share-popover-view'
EditEmailSettingsView = require 'app/scripts/views/board-menu/edit-email-settings-view'
CopyBoardView = require 'app/scripts/views/board/copy-board-view'
ConvertToTemplateView = require 'app/scripts/views/board/convert-board-template-view'
WindowSize = require 'app/scripts/lib/window-size'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
{ Noun, Verb, track, trackUe } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
boardMenuMore = require 'app/scripts/views/templates/board_menu_more'
{ dontUpsell } = require '@trello/config'
ModelLoader = require 'app/scripts/db/model-loader'
BoardAddToTeam = require 'app/scripts/views/board-menu/board-add-to-team-view'
BoardMenuSettingsView = 'views/board-menu/board-settings-view'
{ featureFlagClient } = require '@trello/feature-flag-client'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
{ renderComponent } = require 'app/src/components/ComponentWrapper'
{ UpgradePromptFull } = require 'app/src/components/UpgradePrompts/UpgradePromptFull'
{ UpgradePromptPill } = require 'app/src/components/UpgradePrompts/UpgradePromptPill'
{ renderUpgradePrompt } = require 'app/src/components/UpgradePrompts/renderUpgradePrompt'
{ IconName } = require 'app/common/components/controls/icon'
{ PlanSelectionOverlay } = require 'app/src/components/FreeTrial/PlanSelection'

TEMPLATES_ALERT_TIMEOUT = 1000

module.exports = class BoardMenuMoreView extends View
  viewTitleKey: 'more'

  initialize: ({ @sidebarView }) ->
    @makeDebouncedMethods 'render'

    @listenTo @model,
      'change:subscribed': @renderSubscribeState
      'change:prefs.isTemplate': @renderDebounced
      'change:prefs.permissionLevel': @renderDebounced
      'change:idOrganization': @renderDebounced
      'change:memberships': @renderDebounced

    @listenTo @model, 'cancel-add-to-team', =>
      @addToTeam = false
      @render()
    @listenTo @model, 'add-to-team', =>
      if !@model.owned()
        # We aren't an admin on this board so redirect to business-class page
        window.location = '/business-class'
      else
        @addToTeam = true
        @render()

    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)
    @freeTrialEnabled = featureFlagClient.get('btg.free-trial-existing-teams', false)

  className: 'board-menu-content-frame'

  events:
    'click .js-open-collections': 'openCollections'
    'click .js-open-settings': 'openSettings'
    'click .js-open-stickers': 'openStickers'
    'click .js-open-labels': 'openLabels'
    'click .js-open-archive': 'openArchivedItems'
    'click .js-share': 'shareBoard'
    'click .js-email': 'openEmailSettings'
    'click .js-board-subscribe': 'toggleSubscribe'
    'click .js-copy-board': 'copyBoard'
    'click .js-close-board': 'closeConfirm'
    'click .js-leave-board': 'leaveConfirm'
    'click .js-short-url': 'selectUrl'
    'click .js-make-template': 'makeTemplate'
    'click .js-convert-to-board': 'convertToBoard'
    'submit form': 'cancel'

  remove: ->
    @unmountCollectionsPromptPill?()
    @unmountCollectionsPromptFull?()
    @unmountTemplatesPromptPill?()
    super

  render: (e) ->
    # clears sidebar menu
    @$el.empty()

    me = Auth.me()
    board = @model

    data = @model.toJSON()
    data.canJoin = @model.canJoin()
    data.canInviteMembers = @model.canInviteMembers()
    data.confirmed = me.get('confirmed')
    data.isLoggedIn = me.isLoggedIn()

    org = @model.getOrganization()

    orgBillingUrl = if org then Controller.getOrganizationBillingUrl(org)
    orgId = if org then org.id

    data.canCloseBoard = @model.owned() || (org?.isFeatureEnabled('superAdmins') && org?.owned())

    data.editableByMember = @model.editableByMember(me)
    data.canLeaveBoard = (@model.isMemberObserver(me) || @model.editableByMember(me)) && me.getMembershipData(@model).canRemove
    data.canCloseOrLeave = data.canLeaveBoard || data.canCloseBoard

    data.pLevelClass = BoardDisplayHelpers.getPermLevelIconClassForBoard(@model)
    data.pLevelAltText = BoardDisplayHelpers.getPermLevelAltTextForBoard(@model)
    data.helperText = l(['board perms', @model.getPermLevel(), 'short summary'])

    collectionsEnabled = org?.isFeatureEnabled('tags')
    data.showCollections = @model.hasOrganization() && (collectionsEnabled || !dontUpsell)

    data.hasMultipleMembers = @model.get('memberships')?.length > 1
    data.isAtOrOverFreeBoardLimit = @model.getOrganization()?.isAtOrOverFreeBoardLimit()
    data.isOrgBcOrEnt = !!(org?.isBusinessClass() || org?.belongsToRealEnterprise())
    data.isAdmin = @model.ownedByMember(me)

    data.isTemplate = @model.isTemplate()
    data.canBeTemplate = @model.getPermLevel() == 'public' || data.isOrgBcOrEnt
    data.showTemplateUpgrade = @model.hasOrganization() && data.isAdmin && !dontUpsell

    # Don't allow guests on enterprise owned boards to copy them
    isGuest = @model.isGuest(me)
    isPublicTemplate =  @model.isPublic() && @model.isTemplate()
    isNonMember = !@model.isMember(me) && !@model.canJoin()
    isManagedEntMember = @model.get('idEnterprise') && me.isManagedEntMemberOf(@model.get('idEnterprise'))

    # Guests on Enterprise boards cannot copy them unless they are owned by the enterprise
    if board.get('enterpriseOwned') && isGuest && !isManagedEntMember
      data.canCopyBoard = false
    # If the board is self-joinable and has a permissionLevel of
    # `org` or `enterprise` visible, assume that they can copy the
    # board since they've gotten this far in loading the UI
    # NOTE: this is a temporary fix which can be removed when
    # org-joinable boards has shipped
    else if @model.allowsSelfJoin() && @model.getPref('permissionLevel') in ['org', 'enterprise']
      data.canCopyBoard = true
    # Non-members viewing a public Enterprise board cannot copy it unless it is also a template
    else if board.get('enterpriseOwned') && isNonMember && !isPublicTemplate
      data.canCopyBoard = false
    else
    # Allow copy in all other circumstances
      data.canCopyBoard = true

    if @addToTeam
      @renderAddToTeam()
    else
      @$el.html(boardMenuMore(data))

      pillMountNode = @$el.find('.js-board-menu-pill-collections-upgrade')[0]
      onClickCollectionUpgradePill = =>
              trackUe({
                category: Noun.BOARD_MENU,
                verb: Verb.OPENS,
                directObj: Noun.TEAM_PAGE_BC_TAB,
                method: 'by clicking pill upgrade prompt in board menu more section'
              })
              if @sendGASEvent
                Analytics.sendUIEvent({
                  action: 'clicked',
                  actionSubject: 'pill',
                  actionSubjectId: 'collectionsBcUpgradePill',
                  source: 'boardMenuDrawerMoreScreen'
                })
              if @freeTrialEnabled
                tempNode = document.createElement('span')
                pillMountNode.appendChild(tempNode)
                renderComponent(
                  React.createElement(PlanSelectionOverlay, {
                    onContinue: => window.location.assign('/business-class')
                    orgId: orgId
                    onClose: =>
                      ReactDOM.unmountComponentAtNode(tempNode)
                      tempNode.remove()
                    }),
                  tempNode
                )

      if @model.hasOrganization()
        @unmountCollectionsPromptPill = renderUpgradePrompt(
          React.createElement(UpgradePromptPill, {
            iconName: IconName.BusinessClass
            cta: l(['upgrade prompt', 'upgrade'])
            ctaLink: if @freeTrialEnabled then '' else orgBillingUrl
            ctaOnClick: onClickCollectionUpgradePill
          })
          , @$el.find('.js-board-menu-pill-collections-upgrade')[0]
          , {
            boardModel: board
          }
          , data.showCollections
        )

        @unmountCollectionsPromptFull = renderUpgradePrompt(
          ({ dismiss }) ->
            props =
              headline: l(['upgrade prompt', 'board menu', 'collections', 'headline-2']),
              content: l(['upgrade prompt', 'board menu', 'collections', 'content-2']),
              className: 'board-menu-prompt-collections',
              cta: l(['upgrade prompt', 'learn more']),
              ctaLink: orgBillingUrl,
              orgId: orgId,
              source: 'boardMenuDrawerMoreScreen'
              ctaOnClick: =>
                trackUe({
                  category: Noun.BOARD_MENU,
                  verb: Verb.OPENS,
                  directObj: Noun.BC_MODAL,
                  method: 'by clicking full upgrade prompt in board menu more section'
                })
              iconName: IconName.Collection,
              isDismissable: true
              onDismiss: dismiss

            React.createElement(UpgradePromptFull, props)
          , @$el.find('.js-board-menu-prompt-collections')[0]
          , {
              promptID: 'ad-bc-prompt-upgrade-board-more-collection'
              boardModel: @model
            }
        )

        templatesPromptPillRoot = @$el.find('.js-board-menu-pill-templates-upgrade')[0]
        @unmountTemplatesPromptPill = renderUpgradePrompt(
          React.createElement(UpgradePromptPill, {
            iconName: IconName.BusinessClass
            cta: l(['upgrade prompt', 'upgrade'])
            ctaLink: if @freeTrialEnabled then '' else orgBillingUrl
            ctaOnClick: =>
              trackUe({
                category: Noun.BOARD_MENU,
                verb: Verb.OPENS,
                directObj: Noun.TEAM_PAGE_BC_TAB,
                method: 'by clicking make template upgrade prompt in board menu more section'
              })
              if @sendGASEvent
                Analytics.sendUIEvent({
                  action: 'clicked',
                  actionSubject: 'pill',
                  actionSubjectId: 'makeTemplateBcUpgradePill',
                  source: 'boardMenuDrawerMoreScreen'
                })

              if @freeTrialEnabled
                tempNode = document.createElement('span')
                templatesPromptPillRoot.appendChild(tempNode)

                renderComponent(React.createElement(PlanSelectionOverlay, {
                    orgId: orgId,
                    onContinue: => window.location.assign('/business-class')
                    onClose: ->
                      ReactDOM.unmountComponentAtNode(tempNode)
                      tempNode.remove()
                  }),
                  tempNode, {
                    boardModel: @model
                  }
                )
          })
          , templatesPromptPillRoot
          , {
            boardModel: board
          }
          , data.showCollections
        )

      @renderSubscribeState()

    @

  renderAddToTeam: ->
    ModelLoader.loadMyOrganizations()

    @appendSubview @subview(BoardAddToTeam, @model, {
      menuType: "More"
    })

  renderSubscribeState: ->
    @$('.js-subscribed-state').toggleClass('hide', !@model.get('subscribed'))
    return

  openCollections: (e) ->
    Util.stop(e)

    @sidebarView.pushView 'collections'
    return

  openSettings: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'settings'
    return

  openLabels: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'labels'
    return

  openStickers: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'stickers'
    return

  openArchivedItems: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'archive'
    return

  shareBoard: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$(e.target).closest('.js-share')
      view: new SharePopoverView({ @model, @modelCache })

    # Analytics migration: moving to a screen event in the subview
    track("Board Menu", "Open Share, Print, and Export Menu")
    return

  openEmailSettings: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$(e.target).closest('.js-email')
      view: new EditEmailSettingsView({ @model, @modelCache })

    # Analytics migration: moving to a screen event in the subview
    track('Board Menu', 'Open Email Settings - Menu')
    return

  copyBoard: (e) ->
    Util.stop(e)

    if !$(e.target).hasClass('disabled')
      track("Board Menu", "Open Copy Board")
      @sidebarView.sendClickedDrawerNavItemEvent('more', 'copyBoard')

      PopOver.toggle
        elem: @$(e.target).closest('.js-copy-board')
        view: new CopyBoardView({ @model, @modelCache })

    return

  toggleSubscribe: (e) ->
    Util.preventDefault(e)

    if !$(e.target).hasClass('disabled')
      @model.subscribe !@model.get('subscribed')
      track("Board Menu", "Subscribe/Unsubscribe")
      @sidebarView.sendClickedDrawerNavItemEvent(
        'more',
        'watch',
        { watchEnabled: @model.get('subscribed') }
      )
      if @sendGASEvent
        Analytics.sendTrackEvent
          action: if @model.get('subscribed') then 'subscribed' else 'unsubscribed'
          actionSubject: 'board'
          source: 'boardMenuDrawerMoreScreen'
          containers:
            board:
              id: @model.id

    return

  closeConfirm: (e) ->
    Util.stop(e)

    track("Board Menu", "Open Close Menu")
    @sidebarView.sendClickedDrawerNavItemEvent('more', 'closeBoard')

    Confirm.toggle 'close board',
      elem: $(e.target).closest('a')
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.close()
        track("Board", "Close Board")
        if @sendGASEvent
          Analytics.sendTrackEvent
            action: 'closed'
            actionSubject: 'board'
            source: 'boardMenuDrawerMoreScreen'
            containers:
              board:
                id: @model.id

    return

  leaveConfirm: (e) ->
    Util.stop(e)
    track("Board Menu", "Open Leave Menu")
    @sidebarView.sendClickedDrawerNavItemEvent('more', 'leaveBoard')

    me = Auth.me()
    key = me.removeMembershipConfirmationKey(@model)

    Confirm.toggle key,
      elem: $(e.target).closest('a')
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.removeMember(me)
        track("Board", "Leave Board")
        if @sendGASEvent
          Analytics.sendTrackEvent
            action: 'left'
            actionSubject: 'board'
            source: 'boardMenuDrawerMoreScreen'
            containers:
              board:
                id: @model.board
    return

  selectUrl: (e) ->
    @$('.js-short-url').focus().select()

  cancel: (e) ->
    Util.stop(e)
    false

  makeTemplate: (e) ->
    Util.stop(e)

    trackUe('board menu', 'opens', 'create template menu', '', '', 'by clicking create template button',
      { boardId: @model.id, teamId: @model.getOrganization()?.id })
    @sidebarView.sendClickedDrawerNavItemEvent('more', 'makeTemplateFromBoard')

    if !$(e.target).hasClass('disabled')
      PopOver.toggle
        elem: @$(e.target).closest('.js-make-template')
        view: new ConvertToTemplateView({
          @model,
          @modelCache
        })

  convertToBoard: ->
    Alerts.show('converting', 'info', 'templates', TEMPLATES_ALERT_TIMEOUT)
    @model.setPref('isTemplate', false).save()

    trackUe('board menu', 'converts', 'template', 'to board', '', 'by clicking template toggle',
      { boardId: @model.id, teamId: @model.getOrganization()?.id })
    @sidebarView.sendClickedDrawerNavItemEvent('more', 'convertToBoard')
